<template>
  <div
    class="flex items-center h-64 py-64 pt-6 pb-2 shadow-inner bg-coverobject-fill shadow-xs pageTitle space-y-2 md:space-y-5"
  >
    <div class="left-0 w-full px-4 mb-5 text-white py- sm:px-8 lg:px-16 xl:px-40 2xl:px-64 xl:py-2">
      <h1
        :class="
          `text-2xl leading-9 font-extrabold text-${color}-900 tracking-tight text-white sm:text-4xl sm:leading-10 md:text-5xl md:leading-14`
        "
      >
        {{ title }}
      </h1>
      <p class="text-lg text-gray-500 leading-7">{{ slogan }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PageTitle",
  props: {
    title: {
      type: String,
      required: true,
    },
    slogan: {
      type: String,
      required: false,
    },
    color: {
      type: String,
      default: "white",
      required: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.pageTitle {
  position: relative;
  filter: FlipV;
  background-size: cover;
  box-shadow: inset 4px 2px -2px gray;
  top: 85px;
  background-position: center;
  background-image: url("../../assets/pasek-menu.jpg");
}
</style>
